import { builder } from 'common/js/configs/';
import { commonCreativeConfig } from '../common-creative-config';

export const formatConfigUnmarshaller = {
  customTranslations: builder.object('translations', {
    defaultValue: {},
    d:''
  }),
  creative: builder.holder({
    ...commonCreativeConfig,
    name: builder.string('name', {
      l:'',
      d:''
    }),
    showDiscover: builder.boolean('show_discover', {
      defaultValue: false,
      l:'',
      d:''
    }),
    objectFit: builder.string('creative_object_fit', {
      possibleValues: [
        {
          name: 'Cover',
          value: 'cover'
        },
        {
          name: 'Contain',
          value: 'contain'
        }
      ],
      defaultValue: 'contain'
    })
  }),
  previewIsBackgroundColored: builder.boolean('is_background_colored', {
    defaultValue: false,
    l:''
  }),
  backgroundColor: builder.color('preview_background_color', {
    defaultValue: '#FFFFFF',
    l:'',
    d:'',
    if: 'is_background_colored',
    optional: true
  }),
  discoverFontColor: builder.color('discover_font_color', {
    defaultValue: '#000000',
    l:'',
    d:''
  })
};
